// gatsby-browser.js

function normalizeUrl() {
  const { pathname, search, hash } = window.location;
  if (pathname.includes('//')) {
    const cleanPath = pathname.replace(/\/{2,}/g, '/');
    window.history.replaceState(null, '', cleanPath + search + hash);
  }
}

exports.onClientEntry = () => {
  normalizeUrl();
};

exports.onRouteUpdate = () => {
  normalizeUrl();
};